export const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    const day = date.getDate().toString().padStart(2, "0")
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const year = date.getFullYear()
    return `${day}.${month}.${year}`
};

export const truncateText = (text: string | null, maxLength: number) => {
    return text && text.length > maxLength ? `${text.slice(0, maxLength)}...` : text || "";
}

export const isWithinHighlightPeriod = (startDate: string, endDate?: string): boolean => {
    const now = new Date()
    const start = new Date(startDate)
    const end = endDate ? new Date(endDate) : null

    return now >= start && (!end || now <= end)
};

export const hexToRgb = (hex: string): string => {
    // Remove the # if present
    const cleanHex = hex.replace('#', '');
    
    // Convert to RGB values
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);
    return `${r}, ${g}, ${b}`;
};
